/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpLeftIcon24Solid = forwardRef('ArrowDCornerUpLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.44 1.69a1.5 1.5 0 0 1 2.12 2.12L6.372 8H16.5a4.5 4.5 0 0 1 4.5 4.5v9a1.5 1.5 0 1 1-3 0v-9a1.5 1.5 0 0 0-1.5-1.5H6.37l4.19 4.19a1.5 1.5 0 0 1-2.122 2.12l-5.503-5.503a3.263 3.263 0 0 1 0-4.614l5.503-5.504Z" })));
});
